<template>
  <b-card
      title="مدیریت کاربران"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                    label="شماره موبایل یا ایمیل"
                    label-for="Username"
                >
                  <b-form-input
                      v-model="filterOptions.Username"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="شناسه کاربر"
                    label-for="UserId"
                >
                  <b-form-input
                      v-model="filterOptions.UserId"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="تا تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت"
                    label-for="Type"
                >
                  <v-select
                      v-model="filterOptions.Status"
                      dir="rtl"
                      :reduce="x => x.value"
                      :clearable="true"
                      label="text"
                      :options="enums('UserAffiliateStatus')"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="وضعیت پرداخت"
                    label-for="Type"
                >
                  <v-select
                      v-model="filterOptions.PaymentStatus"
                      dir="rtl"
                      multiple
                      :reduce="x => x.value"
                      :clearable="true"
                      label="text"
                      :options="enums('UserAffiliatePaymentStatus')"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
              <b-button
                  variant="gradient-secondary"
                  class="mb-1 mr-1"
                  @click="exportExcel()"
              >خروجی اکسل درامد
              </b-button>
            </div>
          </b-row>
        </div>

        <div>
          <b-row class="mb-2">
            <b-col md="3">
              <div class="d-flex align-items-center p-1 border rounded">
                <b-avatar
                    size="40"
                    variant="light-warning"
                    class="mr-1"
                >
                  <feather-icon
                      size="20"
                      icon="CreditCardIcon"
                  />
                </b-avatar>
                <div>
                  <span class="mb-1 d-block">مجموع پورسانت</span>
                  <h4 class="mb-0 font-weight-bolder">
                    {{ report.SumCommission | price }}
                  </h4>
                </div>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-flex align-items-center p-1 border rounded">
                <b-avatar
                    size="40"
                    variant="light-secondary"
                    class="mr-1"
                >
                  <feather-icon
                      size="20"
                      icon="PercentIcon"
                  />
                </b-avatar>
                <div>
                  <span class="mb-1 d-block">مجموع تخفیف</span>
                  <h4 class="mb-0 font-weight-bolder">
                    {{ report.SumDiscoubt | price }}
                  </h4>
                </div>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-flex align-items-center p-1 border rounded">
                <b-avatar
                    size="40"
                    variant="light-success"
                    class="mr-1"
                >
                  <feather-icon
                      size="20"
                      icon="DollarSignIcon"
                  />
                </b-avatar>
                <div>
                  <span class="mb-1 d-block">مجموع درامد</span>
                  <h4 class="mb-0 font-weight-bolder">
                    {{ report.SumIncome | price }}
                  </h4>
                </div>
              </div>
            </b-col>
            <b-col md="3">
              <div class="d-flex align-items-center p-1 border rounded">
                <b-avatar
                    size="40"
                    variant="light-primary"
                    class="mr-1"
                >
                  <feather-icon
                      size="20"
                      icon="TrendingUpIcon"
                  />
                </b-avatar>
                <div>
                  <span class="mb-1 d-block">کل فروش</span>
                  <h4 class="mb-0 font-weight-bolder">
                    {{ report.SumSale | price }}
                  </h4>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'updateblogcategory', params: { id: data.value }}"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(User)="data">
            <b-link :to="{ name: 'userDetail', params: { id: data.value.Id }}">
              <b-media
                  vertical-align="center"
                  style="align-items: center;"
              >
                <template #aside>
                  <b-avatar
                      :src="data.value.Image"
                  />
                </template>
                <span
                    class="font-weight-bold d-block text-nowrap"
                    style="color: #6e6b7b;"
                >
                  <template v-if="data.value.Name || data.value.Family">{{ data.value.Name }} {{ data.value.Family }}</template>
                  <template v-else>کاربر زیره</template>
                </span>
                <small class="text-muted">{{ data.value.Id }}</small>
              </b-media>
            </b-link>
          </template>

          <template #cell(Status)="data">
            <b-badge
                :variant="enums('UserAffiliateStatus', 'value', data.value, 'badge')"
            >
              {{ enums('UserAffiliateStatus', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(Coupon)="data">
            <b-badge
                @click="copy(data.value.Code)"
                v-b-tooltip.click.focus.v-dark
                title="کپی شد"
                variant="light-primary"
                :id="data.value.Code"
            >
              {{ data.value.Code }}
            </b-badge>
          </template>

          <template #cell(CreatedAt)="data">
            {{ data.value | date }}
          </template>

          <template #cell(Income)="data">
            {{ data.value | price }}
          </template>

          <template #cell(Balance)="data">
            {{ data.value | price }}
          </template>

          <template #cell(Holding)="data">
            {{ data.value | price }}
          </template>

          <template #cell(actions)="data">

            <div
                class="text-nowrap"
            >
              <b-link @click="showModal(data.item)">
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                />
              </b-link>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>

    <b-modal
        v-model="isShow"
        v-if="isShow"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="تخصیص رژیم"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
    >
      <b-row>
        <b-col cols="12">
          <b-form-group
              label="نام بانک"
              label-for="Title">
            <b-form-input
                v-model="row.Bank"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
              label="نام صاحب حساب"
              label-for="Title">
            <b-form-input
                v-model="row.Owner"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
              label="شماره شبا"
              label-for="Title">
            <b-form-input
                v-model="row.IBAN"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
              label="وضعیت"
              label-for="Status">
            <v-select
                v-model="row.Status"
                :options="enums('UserAffiliateStatus')"
                dir="rtl"
                label="text"
                :clearable="false"
                :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
              label="توضیحات"
              label-for="Description">
            <b-form-textarea
                id="Description"
                v-model="row.Description"
                name="Description"
                rows="3"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: "UserAffiliate",
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD'),
        Page: 1,
        Status: null,
        PaymentStatus: [],
        Username: null,
        UserId: null
      },
      isShow: false,
      row: null,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'User',
          label: 'کاربر',
        },
        {
          key: 'Coupon',
          label: 'کد تخفیف',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
        },
        {
          key: 'Income',
          label: 'درآمد',
        },
        /*{
          key: 'Income',
          label: 'کل درآمد',
        },*/
        {
          key: 'Balance',
          label: 'قابل تسویه',
        },
        {
          key: 'OrderCount',
          label: 'دفعات موفق',
        },
        {
          key: 'FailedOrderCount',
          label: 'دفعات ناموفق',
        },
        {
          key: 'Holding',
          label: 'موجودی',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      report: []
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
    this.getReport()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.useraffiliate.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    getReport() {
      let data = {
        FromDate: this.filterOptions.FromDate,
        ToDate: this.filterOptions.ToDate
      }
      this.$http.post(this.$api.useraffiliate.report, data)
          .then(res => {
            this.report = res.data
            console.log(res)
          })
          .finally(() => {
            this.loading = false
          })
    },
    copy(code) {
      this.$copyText(code)
      setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip', code)
      }, 1000)
    },
    showModal(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.isShow = true
    },
    save(){
      this.$http.post(this.$api.useraffiliate.update, this.row).then(() => {
        this.update()
      })
    },
    exportExcel() {

      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = 'user-affiliate-income.xls'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      xmlHttpRequest.open("GET", '/api/useraffiliate/incomeExcel')
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send(JSON.stringify(this.filterOptions))
    }
  }
}
</script>